import * as pdfjsLib from 'pdfjs-dist';

// pdf.js 4.x only ships the worker as an ES module (.mjs); the old
// pdf.worker.min.js URL 404s and silently broke PDF rendering
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.mjs`;

export default pdfjsLib;
